import { Result } from '@doda/common/src/interfaces/api/recommendPanel';
import { MarkTop4AsHighlyRecommendedAbTestPattern } from '../../types/markTop4AsHighlyRecommend';
import { RecommendType } from '../../constants/recommendType';
import { MARK_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP } from '../../constants/markTop4AsHighlyRecommend';

/**
 * Check if recommendation panel should be marked
 * DODASITE-23338: TOP page - Mark Top 4 Recommended jobs popup A/B test
 *
 * @param recommendType - Type of recommendation
 * @param TARGET_RECOMMEND_TYPES - Target recommendation panel types for marking
 * @returns Whether this panel type should be marked
 */
export const isTargetRecommendType = (
  recommendType: RecommendType,
  TARGET_RECOMMEND_TYPES: RecommendType[]
): boolean => {
  return TARGET_RECOMMEND_TYPES.includes(recommendType);
};

/**
 * Mark top 4 results as highly recommended
 *
 * Marks the top 4 highest score recommendations when:
 * - User is logged in
 * - AB test pattern is TEST
 * - There are more than 4 items in the list
 * - Recommendation type is one of the target types
 *
 * @param results - Array of job recommendations
 * @param isLoggedIn - Whether user is logged in
 * @param recommendType - Type of recommendation panel
 * @param abTestPattern - AB test pattern (ORIGINAL, TEST, TEST1, TEST2 or FAILED)
 * @param TARGET_RECOMMEND_TYPES - list of target recommend types
 * @returns Array of results with isHighlyRecommended flag set for top 4
 */
export const markTop4AsHighlyRecommended = (
  results: Result[],
  isLoggedIn: boolean,
  recommendType?: RecommendType,
  abTestPattern?: MarkTop4AsHighlyRecommendedAbTestPattern,
  TARGET_RECOMMEND_TYPES: RecommendType[] = []
): Result[] => {
  // Only mark if logged in, in TEST pattern, and list has more than 4 items
  if (
    !isLoggedIn ||
    results.length <= 4 ||
    abTestPattern !== MARK_TOP4_AS_HIGHLY_RECOMMENDED_AB_TEST_GROUP.TEST
  ) {
    return results;
  }

  if (
    recommendType &&
    !isTargetRecommendType(recommendType, TARGET_RECOMMEND_TYPES)
  ) {
    return results;
  }

  // Mark the first 4 items (index 0-3) as highly recommended
  return results.map((result, index) => ({
    ...result,
    isHighlyRecommended: index < 4,
  }));
};
